// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-submenu.user>.el-submenu__title{padding:0!important}.el-aside .el-menu{border-right:none}", ""]);
// Exports
module.exports = exports;
